import type { SVGProps } from 'react';

/** Figma `music-note.svg` — `tools/make-icon-components.py`가 만든다. 손으로 고치지 않는다. */
export const MusicNoteIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.40909 9.9684L16.1364 7.19174V11.8083C15.6771 11.5442 15.1312 11.391 14.5455 11.391C12.9137 11.391 11.5909 12.5793 11.5909 14.0452C11.5909 15.511 12.9137 16.6993 14.5455 16.6993C16.1772 16.6993 17.5 15.511 17.5 14.0452C17.5 14.0452 17.5 14.0452 17.5 14.0452L17.5 6.24298C17.5 5.30966 17.5 4.52693 17.4269 3.90328C17.4166 3.81514 17.4043 3.72752 17.3909 3.64575C17.3205 3.21969 17.196 2.82223 16.9558 2.49032C16.8357 2.32437 16.6867 2.1748 16.501 2.04625C16.4661 2.02215 16.43 1.99878 16.3926 1.97619L16.3851 1.97168C15.7421 1.58729 15.0194 1.61478 14.2748 1.78522C13.5547 1.95006 12.662 2.28574 11.5673 2.69737L9.66361 3.41315C9.15048 3.60607 8.71574 3.76951 8.37452 3.9388C8.01147 4.11891 7.69875 4.33135 7.46422 4.64792C7.2297 4.96449 7.1323 5.30565 7.08751 5.67604C7.04542 6.02416 7.04544 6.44752 7.04545 6.94721V13.4416C6.58623 13.1775 6.04029 13.0244 5.45455 13.0244C3.82279 13.0244 2.5 14.2127 2.5 15.6785C2.5 17.1444 3.82279 18.3327 5.45455 18.3327C7.0863 18.3327 8.40909 17.1444 8.40909 15.6785C8.40909 15.6785 8.40909 15.6786 8.40909 15.6785L8.40909 9.9684Z"
      fill="currentColor"
    />
  </svg>
);
